import { ContentBlockFragment, KolProfileBaseFragment } from '@graphqlTypes/sitecore';
import { makeAutoObservable } from 'mobx';

/** 监听video type, 用于KOL leaderboard 和 betpick 的 video WA */
class VideoStore {
    videoType = '';
    videoContentBlock?: KolProfileBaseFragment | ContentBlockFragment | undefined;
    raceID = '';
    kolName = '';
    constructor() {
        makeAutoObservable(this);
    }

    setVideoType(value: string) {
        this.videoType = value;
    }
    setkolName(value: string) {
        this.kolName = value;
    }
    setVideoContentBlock(videoContentBlock: KolProfileBaseFragment | ContentBlockFragment) {
        this.videoContentBlock = videoContentBlock;
    }

    setraceID(raceID: string) {
        this.raceID = raceID;
    }

    setDefaults() {
        this.videoType = '';
        this.videoContentBlock = undefined;
        this.raceID = '';
    }

    get GetVideoType() {
        return this.videoType;
    }
    get GetVideoContentBlock() {
        return this.videoContentBlock;
    }
    get GetRaceID() {
        return this.raceID;
    }
    get GetKolName() {
        return this.kolName;
    }
}

const videoStore = new VideoStore();
export default videoStore;
